<template>
<!-- 安卓生效 -->
  <meta content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" name="viewport" />
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },

  //页面刷新 持久化操作
  created() {
    //在页面加载时读取 localStorage 里的状态信息
    //（存 localStorage 而非 sessionStorage：web-view 每次重开都会清空 sessionStorage，
    //  会导致登录态与 loginUser 丢失 → 反复要求登录 + 首页渲染空白数字）
    if (localStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem('store'))));
    }

    //在页面刷新时将vuex里的信息保存到localStorage里
    //（web-view 被销毁时 beforeunload 不保证触发，store/index.js 里已用 subscribe 兜底）
    window.addEventListener('beforeunload', () => {
      if (JSON.stringify(this.$store.state)){
        localStorage.setItem('store', JSON.stringify(this.$store.state));
      }
    });
  }
}
// /*禁止ios缩放，双击和双指*/
// window.onload = function() {
//   document.addEventListener("touchstart", function(event) {
//     if (event.touches.length > 1) {
//       event.preventDefault();
//     }
//   });
//   var lastTouchEnd = 0;
//   document.addEventListener(
//       "touchend",
//       function(event) {
//         var now = new Date().getTime();
//         if (now - lastTouchEnd <= 300) {
//           event.preventDefault();
//         }
//         lastTouchEnd = now;
//       },
//       false
//   );
//   document.addEventListener("gesturestart", function(event) {
//     event.preventDefault();
//   });
// };
/*禁止ios缩放，双击和双指*/
window.onload = function() {
  document.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function(event) {
    event.preventDefault()
  })
}
</script>


<style>
body {
  font-size: 16px;
  background-color: #f8f8f8;
  -webkit-font-smoothing: antialiased;
}
.CommonButton {
  margin-top: 10px;
  margin-left: 5px;
}
/*html,boby {*/
/*  margin: 0px;*/
/*  padding: 0px;*/
/*}*/

</style>
